import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useControlAuth } from '../ControlAuthContext';
import './UserControl.css';

const UserControl = () => {
  const { user } = useControlAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user && user.accesstype === 0) {
      const fetchUsers = async () => {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem('controlToken');
        try {
          const response = await axios.get('https://valleyapi-dr9y.onrender.com/api/control/users', {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUsers(response.data.users || []);
        } catch (err) {
          setError('Failed to fetch users');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      fetchUsers();
    } else {
      setLoading(false);
      setError('Access denied');
    }
  }, [user]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="user-control-container">
      <h2>User Control</h2>
      <Link to="/control/user-control/create" className="create-user-button">Create User</Link>
      <table className="user-control-table">
        <thead>
          <tr>
            <th>UserID</th>
            <th>Email</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.userid}>
              <td>{u.userid}</td>
              <td>{u.email}</td>
              <td>{u.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {users.length === 0 && <p>No users found.</p>}
    </div>
  );
};

export default UserControl;